export { 
  setupPovertyPopups,
  clickPovertyPopups,
} from './povertyPopups'

export { 
  counterUp,
} from './impactCounter'

export {
  videoToggle,
  loadTheVideo,
} from './videoToggle.js'

export {
  heroAnimation,
  whyExistAnimation,
  whereOperateAnimation,
  whatPovertyAnimation,
  ourImpactAnimation,
  yourImpactAnimation
} from './scrollingAnimations.js'

export {
  persona1Animation,
  persona2Animation,
  persona3Animation
} from './personaAnimations.js'


// export {
//   africaMapAnimations
// } from './africaMapAnimations.js'
